import { USERTYPE_LIST, USERTYPE_CHANGE_STATUS, USERTYPE_ADDEDIT, USERTYPE_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const UserTypeListApi = (payload) => {
    return apiInstance.post(USERTYPE_LIST, payload, {
        headers: authHeader(),
    });
};

export const UserTypeChangeStatusApi = (payload) => {
    return apiInstance.post(USERTYPE_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditUserTypeApi = (payload) => {
    return apiInstance.post(USERTYPE_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const DeleteUserTypeApi = (payload) => {
    return apiInstance.post(USERTYPE_DELETE, payload, {
        headers: authHeader(),
    });
};